import { render } from "./supportOverview.vue?vue&type=template&id=ea306c16&scoped=true&ts=true"
import script from "./supportOverview.vue?vue&type=script&lang=ts"
export * from "./supportOverview.vue?vue&type=script&lang=ts"

import "./supportOverview.vue?vue&type=style&index=0&id=ea306c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea306c16"]])

export default __exports__